import type { CustomFilterProps } from "ag-grid-react";
import React from "react";
import { useSelector } from "react-redux";
import DepartmentName from "src/containers/department/Name";
import { getDepartments, getUsersById } from "src/reducers";
import type { Department, State } from "src/types";
import MultiSelectFilter from "src/components/AgGrid/Filters/MultiSelectFilter";

const DepartmentFilter = (props: CustomFilterProps): React.ReactElement => {
  const usersById = useSelector(({ app }: State) => getUsersById(app));
  const departments: Array<Department> = useSelector(({ app }: State) =>
    getDepartments(app),
  );
  const data = { usersById, departments };

  return (
    <MultiSelectFilter
      {...props}
      filterType="department"
      data={data}
      getValueFromData={(data, uid: any) => {
        const user = data.usersById[uid];
        return user?.department ?? null;
      }}
      getSearchText={(deptId) => {
        const dept = data.departments.find((d) => d.id === Number(deptId));
        return dept?.name || "";
      }}
      renderValue={(deptId) => <DepartmentName id={Number(deptId)} />}
    />
  );
};

export default DepartmentFilter;
